/**
 *
 * @module redemptionRequest
 *
 */

import Check from 'check-types';

import InvalidArgumentException from './../exception/invalidArgumentException';

const {
    string
} = Check.assert;

/**
 *
 * @class RedemptionRequest
 *
 */
export default class RedemptionRequest {

    /**
     *
     * @param {String} [promoCode=undefined]
     * @param {String} [redemptionCode=undefined]
     * @throws {InvalidArgumentException}
     *
     */
    constructor(promoCode, redemptionCode) {

        const errorMessage = {
            ctor: 'RedemptionRequest(promoCode, redemptionCode)',
            get promoCode() {
                return `${this.ctor} promoCode should be a String`;
            },
            get redemptionRequest() {
                return `${this.ctor} redemptionRequest should be a String`;
            }
        };

        if (Check.assigned(promoCode)) {
            string(promoCode, errorMessage.promoCode, InvalidArgumentException);
        }

        if (Check.assigned(redemptionCode)) {
            string(redemptionCode, errorMessage.redemptionCode, InvalidArgumentException);
        }

        /**
         *
         * @access public
         * @type {String}
         *
         */
        this.promoCode = promoCode;

        /**
         *
         * @access public
         * @type {String}
         *
         */
        this.redemptionCode = redemptionCode;

    }

}



// WEBPACK FOOTER //
// ./src/services/commerce/redemptionRequest.js